import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { PROXYVOTE_TASK_BASE_PATH } from '../../../../../../../../../features/proxyvote/task/proxyvote-task-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/beta-nxt/proxy-vote-task/_task')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'beta-nxt-proxy-vote-task-list',
        label: 'BetaNXT',
        to: PROXYVOTE_TASK_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
